/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import {
  // @ts-ignore
  isAndroidChrome,
  // @ts-ignore
  isIOS,
} from '../../../helpers/serverRenderingUtils';
import { useBrowserSize } from '../../contexts/BrowserSize';
import { AppButtons } from '../../screens/HomePage/components/AppButtons';
// @ts-ignore
import LinkStyles from '../PublicWebsiteNav/LinkStyles.sass';
import { SocialLink } from './components/SocialLink';
import { clickedFooterLink } from './events';
import {
  AnchorLogo,
  AppLinksContainer,
  CopyrightContainer,
  FooterContainer,
  LinksAndSocialContainer,
  LinksContainer,
  LogoAppStoreContainer,
  Rule,
  SocialContainer,
  TabletWrapper,
} from './styled';

const Footer = () => {
  const { width } = useBrowserSize();
  return (
    <FooterContainer>
      <LogoAppStoreContainer>
        <a
          href="/"
          onClick={() => clickedFooterLink('Home')}
          aria-label="link to home page"
        >
          <AnchorLogo
            src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png"
            srcSet="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4.png 1x, https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-4@2x.png 2x"
            alt="Anchor logo links to the homepage"
          />
        </a>
        <AppLinksContainer
          css={(false || getIsMobile()) && { 'justify-content': 'flex-end' }}
        >
          <AppButtons
            clickEventLocation="Footer"
            clickEventSection={null}
            appStoreUrl="https://app.adjust.com/dyvodl2?redirect=https%3A%2F%2Fapps.apple.com%2Fapp%2Fapple-store%2Fid1056182234"
            playStoreUrl="https://app.adjust.com/ju55aik?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dfm.anchor.android"
            mobileAppStoreUrl="https://app.adjust.com/t1g5iu3?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
            mobilePlayStoreUrl="https://app.adjust.com/qohxi8g?redirect=https%3A%2F%2Fanchor.fm%2Fapp"
          />
        </AppLinksContainer>
      </LogoAppStoreContainer>
      <Rule />
      <LinksAndSocialContainer>
        {getFooterContentInOrder(width)}
      </LinksAndSocialContainer>
    </FooterContainer>
  );
};

function getIsMobile() {
  return isIOS() || isAndroidChrome();
}

function getFooterContentInOrder(width: number) {
  if (width <= 600) {
    return (
      <React.Fragment>
        <Links />
        <Rule />
        <SocialLinks />
        <Copyright />
      </React.Fragment>
    );
  }
  if (width <= 1024) {
    return (
      <React.Fragment>
        <Links />
        <TabletWrapper>
          <Copyright />
          <SocialLinks />
        </TabletWrapper>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <Copyright />
      <Links />
      <SocialLinks />
    </React.Fragment>
  );
}

function Links() {
  return (
    <LinksContainer>
      <a
        onClick={() => clickedFooterLink('About')}
        className={LinkStyles.link}
        href="/about"
        target="_blank"
        rel="noopener noreferrer"
      >
        ABOUT
      </a>
      <a
        onClick={() => clickedFooterLink('Jobs')}
        className={LinkStyles.link}
        href="/jobs"
        target="_blank"
        rel="noopener noreferrer"
      >
        JOBS
      </a>
      <a
        onClick={() => clickedFooterLink('Legal')}
        className={LinkStyles.link}
        href="/tos"
        target="_blank"
        rel="noopener noreferrer"
      >
        LEGAL
      </a>
      <a
        onClick={() => clickedFooterLink('Help')}
        className={LinkStyles.link}
        href="https://help.anchor.fm"
        target="_blank"
        rel="noopener noreferrer"
      >
        HELP
      </a>
    </LinksContainer>
  );
}

function SocialLinks() {
  return (
    <SocialContainer>
      <SocialLink platformName="twitter" />
      <SocialLink platformName="instagram" />
      <SocialLink platformName="facebook" />
    </SocialContainer>
  );
}
function Copyright() {
  return (
    <CopyrightContainer>
      2020 &copy; Anchor FM Inc. All rights reserved.
    </CopyrightContainer>
  );
}

export { Footer };
